// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__jmD6x","content":"LayoutSettings_content__3V9Pr"};